<template>
  <el-dialog
    v-draggable
    :title="dialogOptions.dialogTitle"
    :visible.sync="btnRelateDialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :width="dialogOptions.dialogWidth ? formatterWidthOrHeightStyle(dialogOptions.dialogWidth) : '1200px'"
    @closed="expose_hideDialog"
  >
    <div
      :style="{
        height: dialogOptions.dialogHeight ? formatterWidthOrHeightStyle(dialogOptions.dialogHeight) : '650px',
        overflow: 'auto',
        width: `calc(${dialogOptions.dialogWidth ? formatterWidthOrHeightStyle(dialogOptions.dialogWidth) : '1200px'} - '40px')`
      }"
    >
      <table-render :ref="curDialogCompRef" :externalParams="externalParams" :relateId="relateId"></table-render>
    </div>
    <span slot="footer">
      <!-- <el-button type="primary" size="small" @click="submitForm"> 提 交 </el-button> -->
      <el-button size="small" @click="expose_hideDialog"> 取 消 </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "InsertDynTableDlg",
  data() {
    return {
      btnRelateDialogVisible: false,
      dialogOptions: {},
      curDialogCompRef: "tableRender",
      relateId: "",
      externalParams: {}
    };
  },
  methods: {
    /**
     * @param relateId 需要关联的低代码列表id
     * @param dialogOptions 弹窗配置项
     * @param dialogOptions.dialogTitle  弹窗标题
     * @param dialogOptions.dialogHeight  高度设置
     * @param dialogOptions.dialogWidth  宽度设置
     * @param {Object} externalParams  额外参数，关联的低代码列表获取数据时会放在请求参数中
     */
    openDlg(relateId, dialogOptions, externalParams) {
      this.btnRelateDialogVisible = true;
      this.relateId = relateId;
      this.dialogOptions = dialogOptions;
      this.externalParams = externalParams;
    },

    expose_hideDialog() {
      this.btnRelateDialogVisible = false;
      this.$emit("closeDlg");
    },
    /**
     * @description:
     * @param {*} length
     * @return {*}
     */
    formatterWidthOrHeightStyle(length) {
      if (typeof length === "string") length = length.trim();
      if (/^\d+$/.test(length)) {
        return `${length}px`;
      } else if (/^\d+(%|px)?$/.test(length)) {
        return length;
      } else {
        console.warn("输入的高度或者宽度格式不正确！");
        return "";
      }
    }
  }
};
</script>
